import {useCallback} from 'react';

import type {User} from 'nutshell-core/users/users-types';

import type {NutFileInput, WidgetFragment as Widget} from 'nutshell-graphql-types';

import {AttachmentsWidget} from '../../../../core-entity/widgets/attachments-widget/components/attachments-widget';

import {useAddAttachmentToLead} from '../graphql/hooks/use-add-attachment-to-lead';
import {useGetAttachmentsForLead} from '../graphql/hooks/use-get-attachments-for-lead';
import {useRemoveAttachmentFromLead} from '../graphql/hooks/use-remove-attachment-from-lead';

interface Props {
    leadId: string;
    user: User | null | undefined;
    widget: Widget;
}

export function LeadAttachmentsWidget(props: Props) {
    const {leadId, user, widget} = props;

    const {files, isLoading: isLoadingGetAttachments} = useGetAttachmentsForLead(leadId);
    const {addAttachmentToLead} = useAddAttachmentToLead();
    const {removeAttachmentFromLead} = useRemoveAttachmentFromLead();

    const handleRemoveAttachment = useCallback(
        (fileId: string) => removeAttachmentFromLead({lead: leadId, fileId}),
        [leadId, removeAttachmentFromLead]
    );

    const handleAddAttachment = useCallback(
        (filesToAdd: NutFileInput[]) =>
            addAttachmentToLead({lead: leadId, files: filesToAdd}, user, files),
        [addAttachmentToLead, files, leadId, user]
    );

    return (
        <AttachmentsWidget
            user={user}
            entityId={leadId}
            widget={widget}
            files={files}
            isLoadingAttachments={isLoadingGetAttachments}
            onRemoveAttachment={handleRemoveAttachment}
            onAddAttachment={handleAddAttachment}
        />
    );
}
